module.exports = __webpack_public_path__ + "img/ga.e52cb2ed.svg";